import axios from '../config/axios';
import { getApiUrl } from '../config/environment';
import { openSignedPrescriptionPdf } from '../services/documentSignatureService';
import { buildPrescriptionPrintHtml } from './prescriptionPrintDocument';
import { isSignedPrescription } from './prescriptionSignature';
import { escapeHtml } from './clinicPrintLetterhead';
import { printClinicHtml } from './clinicPrintHtml';

export async function fetchLinkedPrescription(prescriptionId: string): Promise<any | null> {
  try {
    const { data } = await axios.get(getApiUrl(`/clinic/prescriptions/${prescriptionId}`));
    return data?.data ?? null;
  } catch {
    return null;
  }
}

export function buildSignedPrescriptionNoticeHtml(prescription: any): string {
  const code = prescription.signature_verification_code || '—';
  const number = prescription.prescription_number || '';
  return `<div class="attachment-block attachment-block--embedded" style="padding:16px;border:1px solid #99f6e4;border-left:4px solid #0d9488;background:#f0fdfa;border-radius:6px;">
    <div style="font-size:11px;font-weight:700;color:#0f766e;text-transform:uppercase;">Receituário assinado digitalmente</div>
    <div style="font-size:12px;color:#111;margin-top:6px;font-weight:600;">${escapeHtml(number)}</div>
    <div style="font-size:11px;color:#374151;margin-top:4px;line-height:1.6;">
      O documento com validade legal é o PDF assinado em ICP-Brasil.
      Código de conferência: <strong>${escapeHtml(code)}</strong>
    </div>
    <div style="font-size:10px;color:#6b7280;margin-top:6px;">O PDF assinado será aberto em outra aba ao imprimir este pacote.</div>
  </div>`;
}

export type PrescriptionPrintPart =
  | { kind: 'html'; html: string }
  | { kind: 'signed'; prescription: any };

export async function resolvePrescriptionPrintPart(
  prescriptionId: string,
  extractBodyInner: (fullHtml: string) => string,
): Promise<PrescriptionPrintPart | null> {
  const prescription = await fetchLinkedPrescription(prescriptionId);
  if (!prescription) return null;

  if (isSignedPrescription(prescription)) {
    return { kind: 'signed', prescription };
  }

  try {
    const { data } = await axios.get(getApiUrl(`/clinic/prescriptions/${prescriptionId}/print`));
    const printData = data?.data ?? data;
    const full = buildPrescriptionPrintHtml(printData);
    return {
      kind: 'html',
      html: `<div class="attachment-block attachment-block--embedded">${extractBodyInner(full)}</div>`,
    };
  } catch {
    return null;
  }
}

/** Imprime um receituário vinculado à evolução: PDF assinado ou HTML de rascunho. */
export async function printSingleLinkedPrescription(prescriptionId: string): Promise<void> {
  const prescription = await fetchLinkedPrescription(prescriptionId);
  if (!prescription) throw new Error('Receituário não encontrado.');

  if (isSignedPrescription(prescription)) {
    await openSignedPrescriptionPdf(prescription.id, prescription.signed_pdf_url);
    return;
  }

  const { data } = await axios.get(getApiUrl(`/clinic/prescriptions/${prescriptionId}/print`));
  const printData = data?.data ?? data;
  printClinicHtml(buildPrescriptionPrintHtml(printData));
}
